<template>
  <div>
    <ais-instant-search :search-client="searchClient" index-name="academy_videos" :routing="routing" :insights="true"
      :future="future">

      <header class="header" id="header">

        <ais-search-box v-if="!filtersOpened" class="" placeholder="Search Videos">

          <template #submit-icon>

            <svg xmlns=" http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="16" height="16">
              <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                stroke-width="1.67" transform="translate(1 1)">
                <circle cx="7.11" cy="7.11" r="7.11" />
                <path d="M16 16l-3.87-3.87" />
              </g>
            </svg>
          </template>

        </ais-search-box>
      </header>

      <main class="container">
        <div class="container-wrapper">
          <section class="container-filters">
            <div class="container-header">
              <h2>Filters</h2>

              <ais-clear-refinements data-layout="desktop">
                <template #resetLabel>
                  <div class="clear-filters">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 11 11">
                      <g fill="none" fill-rule="evenodd" opacity=".4">
                        <path d="M0 0h11v11H0z" />
                        <path fill="#000" fill-rule="nonzero"
                          d="M8.26 2.75a3.896 3.896 0 1 0 1.102 3.262l.007-.056a.49.49 0 0 1 .485-.456c.253 0 .451.206.437.457 0 0 .012-.109-.006.061a4.813 4.813 0 1 1-1.348-3.887v-.987a.458.458 0 1 1 .917.002v2.062a.459.459 0 0 1-.459.459H7.334a.458.458 0 1 1-.002-.917h.928z" />
                      </g>
                    </svg>
                    Clear filters
                  </div>
                </template>
              </ais-clear-refinements>

              <ais-stats data-layout="mobile">
                <template #default="{ nbHits }">
                  <span class="ais-Stats-text">
                    <strong>{{ formatNumber(nbHits) }}</strong> results
                  </span>
                </template>
              </ais-stats>
            </div>

            <div class="container-body">
              <ais-panel>
                <template #header> Level </template>

                <template #default="{ currentRefinement, range, refine, canRefine }">
                  <ais-refinement-list attribute="level" :sort-by="['level:desc']" />

                </template>
              </ais-panel>

              <ais-panel>
                <template #header> Category </template>

                <template #default>

                  <ais-refinement-list attribute="category" :sort-by="['category:desc']" />
                </template>
              </ais-panel>

              <ais-panel>
                <template #header> Duration </template>

                <template #default>
                  <ais-range-input attribute="duration">
                    <template #default="{ currentRefinement, range, refine, canRefine }">
                      <vue-slider :min="range.min" :max="range.max" :value="toValue(currentRefinement, range)"
                        :disabled="!canRefine" :lazy="true" :use-keyboard="true" :enable-cross="false" tooltip="always"
                        :duration="0" @change="refine({ min: $event[0], max: $event[1] })">
                        <template #dot="{ index, value }">
                          <div :aria-valuemin="range.min" :aria-valuemax="range.max" :aria-valuenow="value"
                            :data-handle-key="index" class="vue-slider-dot-handle" role="slider" tabindex="0" />
                        </template>
                        <template #tooltip="{ value }">
                          {{ value }}
                        </template>
                      </vue-slider>
                    </template>
                  </ais-range-input>
                </template>
              </ais-panel>
            </div>
          </section>

          <footer class="container-filters-footer" data-layout="mobile">
            <clear-refinements class="container-filters-footer-button-wrapper" @click="toggleFilters" />

            <ais-stats class="container-filters-footer-button-wrapper">
              <template #default="{ nbHits }">
                <button class="button button-primary" @click="toggleFilters">
                  See {{ formatNumber(nbHits) }} results
                </button>
              </template>
            </ais-stats>
          </footer>
        </div>

        <section class="container-results">
          <header class="container-header container-options">

            <ais-sort-by :class-names="{ 'ais-SortBy': 'ais-custom-sort' }" :items="[
              // {
              //   value: 'academy_videos',
              //   label: 'Featured',
              // },
              { value: 'academy_videos_likes_desc', label: 'Likes (Desc)' },

              {
                value: 'academy_videos_views_desc',
                label: 'Views (Desc)',
              },
              {
                value: 'academy_videos_duration_desc',
                label: 'Duration (Desc)',
              },
              {
                value: 'academy_videos_firstPublicationDate',
                label: 'Date  (Desc)',
              },
            ]">
              <template v-slot="{ items, currentRefinement, refine }">
                <!-- <ul>
                  <li v-for="item in items" :key="item.value" :value="item.value">
                    <a href="#" :style="{ fontWeight: item.value === currentRefinement ? 'bold' : '' }"
                      @click.prevent="refine(item.value)">
                      {{ item.label }}
                    </a>
                  </li>
                </ul> -->
                <v-select @change="refine(sortModel)" label="Sort By" color="#1A7D6D" v-model="sortModel" :items="items"
                  item-text="label" outlined></v-select>
              </template>
            </ais-sort-by>


          </header>

          <ais-hits>
            <template #item="{ item }">
              <article class="hit" @click="videoClicked(item)">
                <video-card :video="item"></video-card>
              </article>
            </template>
          </ais-hits>

          <no-results />

          <footer class="container-footer">
            <ais-pagination :padding="2">
              <template #default="{
                currentRefinement,
                pages,
                isFirstPage,
                isLastPage,
                refine,
                createURL,
              }">
                <ul class="ais-Pagination-list">
                  <li class="ais-Pagination-item ais-Pagination-item--previousPage ais-Pagination-item--disabled"
                    v-if="isFirstPage">
                    <span class="ais-Pagination-link">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" width="10" height="10">
                        <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1.143">
                          <path d="M9 5H1M5 9L1 5l4-4" />
                        </g>
                      </svg>
                    </span>
                  </li>

                  <li class="ais-Pagination-item ais-Pagination-item--previousPage" v-if="!isFirstPage">
                    <a class="ais-Pagination-link" :href="createURL(currentRefinement - 1)"
                      @click.prevent="refine(currentRefinement - 1)" aria-label="Previous">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" width="10" height="10">
                        <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1.143">
                          <path d="M9 5H1M5 9L1 5l4-4" />
                        </g>
                      </svg>
                    </a>
                  </li>

                  <li :class="{
                    'ais-Pagination-item': true,
                    'ais-Pagination-item--page': true,
                    'ais-Pagination-item--selected':
                      page === currentRefinement,
                  }" v-for="page in pages" :key="page">
                    <a class="ais-Pagination-link" :href="createURL(page)" :style="{
                      fontWeight: page === currentRefinement ? 'bold' : '',
                    }" @click.prevent="refine(page)">{{ page + 1 }}</a>
                  </li>

                  <li class="ais-Pagination-item ais-Pagination-item--nextPage" v-if="!isLastPage">
                    <a class="ais-Pagination-link" :href="createURL(currentRefinement + 1)"
                      @click.prevent="refine(currentRefinement + 1)" aria-label="Next">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" width="10" height="10">
                        <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1.143">
                          <path d="M1 5h8M5 9l4-4-4-4" />
                        </g>
                      </svg>
                    </a>
                  </li>

                  <li class="ais-Pagination-item ais-Pagination-item--nextPage ais-Pagination-item--disabled"
                    v-if="isLastPage">
                    <span class="ais-Pagination-link">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" width="10" height="10">
                        <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1.143">
                          <path d="M1 5h8M5 9l4-4-4-4" />
                        </g>
                      </svg>
                    </span>
                  </li>
                </ul>
              </template>
            </ais-pagination>
          </footer>
        </section>
      </main>

      <aside data-layout="mobile">
        <button class="filters-button" @click="toggleFilters()">
          <svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 16 14">
            <path d="M15 1H1l5.6 6.3v4.37L9.4 13V7.3z" stroke="black" stroke-width="1.29" fill="none" fill-rule="evenodd"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>

          Filters
        </button>
      </aside>
    </ais-instant-search>
  </div>
</template>

<style scoped>
.ais-custom-sort:after {
  display: none;
}

.ais-custom-sort {
  max-width: 190px;
}

.container-options {
  padding: 2px;
}
</style>



<script>
import algoliasearch from 'algoliasearch';
import VueSlider from 'vue-slider-component';
import getRouting from '../routing';
import { formatNumber } from '../utils';
import ClearRefinements from '../widgets/ClearRefinements.vue';
import NoResults from '../widgets/NoResults.vue';
import store from '@/store/index';
import VideoCard from '../components/VideoCard.vue';


import '../Theme.css';
import '../App.css';
import '../App.mobile.css';
import '../widgets/PriceSlider.css';
// c
export default {
  components: {
    VueSlider,
    ClearRefinements,
    NoResults,
    VideoCard
  },

  created() {
    this.onKeyUp = (event) => {
      if (event.key !== 'Escape') {
        return;
      }
      this.toggleFilters()
    };

    this.onClick = (event) => {
      if (event.target !== this.header) {
        return;
      }

      this.toggleFilters();
    };
  },
  mounted() {
    this.resultsContainer = document.querySelector('.container-results');
    this.header = document.querySelector('#header');

    window.analytics.page('Home');
    // this.index = this.searchClient.initIndex('academy_videos');

    // this.getUserIP();


  },

  data() {
    return {
      searchClient: algoliasearch(
        process.env.VUE_APP_ALGOLIA_APP_ID,
        process.env.VUE_APP_ALGOLIA_KEY
      ),
      future: {
        preserveSharedStateOnUnmount: true,
      },
      index: null,
      routing: getRouting({ indexName: 'academy_videos' }),
      query: null,
      sortModel: "academy_videos_likes_desc"

    };
  },
  watch: {
    filtersOpened(newValue, oldValue) {

      if (newValue) {
        this.openFiltersContainer();
        this.toggleChatWidget('hide');
      } else {
        this.closeFiltersContainer();
        this.toggleChatWidget('minimize');

      }

    },

  },
  computed: {
    filtersOpened() {
      return this.$store.state.search.filtersOpened;
    }
  },
  methods: {

    toggleChatWidget(action) {
      LiveChatWidget.call(action);
    },
    getUserIP() {
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(response => {
          this.userIP = response.ip;


          window.analytics.identify(response.ip, {

          });
        });
    },

    videoClicked(video) {

      this.trackOpenedVideo(video);
      this.$router.push({ name: 'video', params: { id: video.objectID } });

    },
    trackOpenedVideo(video) {

      window.analytics.track('Opened Video', {
        context: 'Home',
        videoId: video.id,
        videoTitle: video.title,
        videoAuthor: video.author.name,
        videoCategory: video.category,
        videoLevel: video.level,

      });

    },
    formatNumber,
    toValue(value, range) {
      return [
        typeof value.min === 'number' ? value.min : range.min,
        typeof value.max === 'number' ? value.max : range.max,
      ];
    },
    toggleFilters() {
      this.$store
        .dispatch('search/TOGGLE_FILTERS_OPENED')
    },
    openFiltersContainer() {

      document.body.classList.add('filtering');
      window.scrollTo(0, 0);
      window.addEventListener('keyup', this.onKeyUp);
      window.addEventListener('click', this.onClick);
    },
    closeFiltersContainer() {

      document.body.classList.remove('filtering');
      this.resultsContainer.scrollIntoView();
      window.removeEventListener('keyup', this.onKeyUp);
      window.removeEventListener('click', this.onClick);
      window.scrollTo(0, 0);
    },
  },
};
</script>
